import $ from 'jquery';

export const deliveryDate = async ( start = 7,end = 12) =>  {
    const firstDate = new Date();
    firstDate.setDate(firstDate.getDate() + start);
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + end);
    const firstDateString = firstDate.toLocaleString('ru', {
        month: 'long',
        day: 'numeric'
    });
    const EndDateString = endDate.toLocaleString('ru', {
        month: 'long',
        day: 'numeric'
    });
    $('.js-delivery-date').html(firstDateString + ' — ' + EndDateString)
}


